import { ApolloQueryResult, gql } from '@apollo/client'
import { customAlphabet } from 'nanoid'

import client from '.'
import { nanoIdCharacters } from '../constants'
import { GetAccountDataSourceOut } from '../types'

export const getAccountDataSource = async (
  accountIDs: string[],
): Promise<ApolloQueryResult<GetAccountDataSourceOut>> => {
  let accountQuery = ``
  const nanoid = customAlphabet(nanoIdCharacters, 10)

  accountIDs.forEach((accountID) => {
    accountQuery += `
        ${nanoid()}:account(
            accountID: "${accountID}"
        ) {
            accountID
            dataSource {
              kind
              connected
            }
          }
      `
  })

  const query = gql`
  query GetAccountDataSource {
      ${accountQuery}
    }
  `

  return client.query({ query })
}
